/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-20 14:53:02
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-27 11:48:05
 */

import { unwrapResult } from '@reduxjs/toolkit'
import { Form, Row, Col, Checkbox, Button, Radio, Input } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { Checks, MedicelListValue } from '../../../../models/setting'
import { getTenantDetail } from '../../tenantSlice'
import styles from '../TenantSetting.module.css'
interface ValueAddedProps {
  zcShoperId?: any
  payStatus: number //米雅聚合支付字体样式
  payStatusYinlian: number //银联聚合支付字体样式
  payStatusKanglin: number //康邻聚合支付字体样式
  replaceMakeStatus: any //代煎设置标题
  payList: any //米雅聚合支付
  payListYinlian: any //银联聚合支付
  payListKanglin: any //康邻聚合支付
  invoiceOptions: any //电子发票
  medicalList: any //医保服务
  formObj: any
  onSettingVisible: (obj: any) => void //医保服务弹窗
  onInvoiceVisible: (obj: any) => void //电子发票弹窗
  onSettingPayVisible: (obj: any) => void //聚合支付弹窗
  onSettingPayVisibleYinlian: (obj: any) => void //银联聚合支付弹窗
  onSettingPayVisibleKanglin: (obj: any) => void //康邻聚合支付弹窗
  onIsReplaceMakeModalVisible: (obj: any) => void //代煎设置弹窗
  formChange: () => void
  onSave: (obj: any, zcShoperId?: any) => void
}

export const ValueAdded = ({
  zcShoperId,
  payStatus, //米雅聚合支付字体样式
  payStatusYinlian, //银联聚合支付字体样式
  payStatusKanglin, //康邻聚合支付字体样式
  replaceMakeStatus, //代煎设置标题
  payList, //米雅聚合支付
  payListYinlian, //银联聚合支付
  payListKanglin, //康邻聚合支付
  invoiceOptions, //电子发票
  medicalList, //医保服务
  formObj,
  onSettingVisible, //医保服务弹窗
  onInvoiceVisible, //电子发票弹窗
  onSettingPayVisible, //聚合支付弹窗
  onSettingPayVisibleYinlian, //银联聚合支付弹窗
  onSettingPayVisibleKanglin, //康邻聚合支付弹窗
  onIsReplaceMakeModalVisible, //代煎设置弹窗
  formChange,
  onSave,
}: ValueAddedProps): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [flag, setFlag] = useState(false)

  const [SCFlag, setSCFlag] = useState('1')

  useEffect(() => {
    if (zcShoperId)
      form.setFieldsValue({
        zcShoperId: zcShoperId,
      })
  }, [zcShoperId])

  useEffect(() => {
    if (!formObj) return
    form.setFieldsValue({
      ...formObj,
      [Checks.LKSC]:
        formObj?.[Checks.LKSC] == '1' || formObj?.[Checks.LKSC] == '2'
          ? true
          : false,
      [Checks.FJSCDXZ]: formObj?.[Checks.FJSCDXZ] || '2',
      [Checks.YDCFZXSQ]: formObj?.[Checks.YDCFZXSQ]
        ? formObj[Checks.YDCFZXSQ].toString().split(',')
        : [],
    })
    setFlag(
      formObj?.[Checks.LKSC] == '1' || formObj?.[Checks.LKSC] == '2'
        ? true
        : false
    )
    setSCFlag(formObj?.[Checks.LKSC])
  }, [formObj])
  return (
    <div style={{ padding: '0 10px', overflowY: 'auto', maxHeight: 'calc(100vh - 220px)' }} className={styles.valueAdded}>
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          const data = {
            ...values,
            zcShoperId: null,
            [Checks.LKSC]: values?.[Checks.LKSC] ? SCFlag : 0,
            [Checks.YDCFZXSQ]: values?.[Checks.YDCFZXSQ]?.length
              ? values[Checks.YDCFZXSQ].join(',')
              : '',
          }
          onSave(data, values?.zcShoperId)
        }}
        onValuesChange={() => formChange()}
      >
        {/* <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='医生电子签名'
              name={Checks.DZQM}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row> */}
        <Row>
          <Col style={{ marginLeft: '50px'}}>
            <Form.Item label='续费模式' name={Checks.XFMS}>
              <Radio.Group>
                <Radio value='1'>开始日期取到期日期</Radio>
                <Radio value='2'>到期日期取续费日期 <span style={{marginLeft:'40px', color: '#999' }}>说明：只作用于到期的机构</span></Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='智能审方'
              name={Checks.ZNSF}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='高级医美病历'
              name={Checks.GJBL}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='公众号'
              name={Checks.WXGZH}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='省异地'
              name={Checks.SYD}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='定制版病历/处方 背景自定义'
              name={Checks.DZBBLCFBJZDY}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='单个附件上传大小限制' name={Checks.FJSCDXZ}>
              <Radio.Group>
                <Radio value='2'>2MB</Radio>
                <Radio value='10'>10MB</Radio>
                <Radio value='30'>30MB</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='商城' name={Checks.LKSC} valuePropName='checked'>
              <Checkbox
                onChange={(e: any) => {
                  setFlag(e?.target?.checked)
                  setSCFlag('1')
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
          {flag ? (
            <Col style={{ marginLeft: '10px' }}>
              <Form.Item label=''>
                <Radio.Group
                  value={SCFlag}
                  onChange={(e: any) => {
                    setSCFlag(e?.target?.value)
                  }}
                >
                  <Radio value='1'>飞康</Radio>
                  <Radio value='2'>珍诚</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          ) : (
            ''
          )}
          {SCFlag == '2' ? (
            <Col style={{ marginLeft: '10px' }}>
              <Form.Item
                label='对方机构编码'
                name='zcShoperId'
                rules={[
                  {
                    required: true,
                    message: '请输入对方机构编码',
                  },
                ]}
              >
                <Input
                  placeholder='请输入对方机构编码'
                  style={{ width: '180px' }}
                />
              </Form.Item>
            </Col>
          ) : (
            ''
          )}
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='辅助诊断'
              name={Checks.ZNFZ}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='医保服务' valuePropName='checked'>
              {medicalList.length !== 0 &&
                medicalList.map((v: MedicelListValue) => (
                  <Button
                    key={v.id}
                    onClick={() => {
                      onSettingVisible({
                        id: v.id,
                        tenantId: v.tenantId,
                        visible: true,
                      })
                      // setSettingVisible({
                      //   id: v.id,
                      //   tenantId: v.tenantId,
                      //   visible: true,
                      // })
                    }}
                    type='link'
                    className={!v.tenantStatus ? styles.underline : ''}
                  >
                    {v.insuranceName}
                  </Button>
                ))}
              <Button
                onClick={() => {
                  onSettingVisible({
                    id: 0,
                    tenantId: location.search.replace('?', ''),
                    visible: true,
                  })
                }}
                type='link'
              >
                添加医保险种
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='电子发票'>
              {invoiceOptions.length !== 0 &&
                invoiceOptions.map((v: any) => (
                  <Button
                    key={v.id}
                    onClick={() => {
                      onInvoiceVisible({
                        id: v.id,
                        tenantId: v.tenantId,
                        visible: true,
                      })
                    }}
                    type='link'
                    className={!v.status ? styles.underline : ''}
                  >
                    {v.supplierName}
                  </Button>
                ))}
              <Button
                onClick={() => {
                  onInvoiceVisible({
                    id: 0,
                    tenantId: location.search.replace('?', ''),
                    visible: true,
                  })
                }}
                type='link'
              >
                添加电子发票
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='米雅聚合支付'>
              {payList !== {} && (
                <Button
                  onClick={() => {
                    onSettingPayVisible({
                      id: 0,
                      tenantId: '0',
                      visible: true,
                    })
                    // setSettingPayVisible({
                    //   id: 0,
                    //   tenantId: '0',
                    //   visible: true,
                    // })
                  }}
                  type='link'
                  className={payStatus == 1 ? '' : styles.underline}
                >
                  米雅
                </Button>
              )}
              <Button
                onClick={() => {
                  onSettingPayVisible({
                    id: 1,
                    tenantId: location.search.replace('?', ''),
                    visible: true,
                  })
                  // setSettingPayVisible({
                  //   id: 1,
                  //   tenantId: location.search.replace('?', ''),
                  //   visible: true,
                  // })
                }}
                type='link'
              >
                添加聚合支付
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='银联聚合支付'>
              {payListYinlian !== {} && (
                <Button
                  onClick={() => {
                    onSettingPayVisibleYinlian({
                      id: 0,
                      tenantId: '0',
                      visible: true,
                    })
                    // setSettingPayVisible({
                    //   id: 0,
                    //   tenantId: '0',
                    //   visible: true,
                    // })
                  }}
                  type='link'
                  className={payStatusYinlian == 1 ? '' : styles.underline}
                >
                  银联
                </Button>
              )}
              <Button
                onClick={() => {
                  onSettingPayVisibleYinlian({
                    id: 1,
                    tenantId: location.search.replace('?', ''),
                    visible: true,
                  })
                  // setSettingPayVisible({
                  //   id: 1,
                  //   tenantId: location.search.replace('?', ''),
                  //   visible: true,
                  // })
                }}
                type='link'
              >
                添加聚合支付
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='康邻聚合支付'>
              {payListKanglin !== {} && (
                <Button
                  onClick={() => {
                    onSettingPayVisibleKanglin({
                      id: 0,
                      tenantId: '0',
                      visible: true,
                    })
                    // setSettingPayVisible({
                    //   id: 0,
                    //   tenantId: '0',
                    //   visible: true,
                    // })
                  }}
                  type='link'
                  className={payStatusKanglin == 1 ? '' : styles.underline}
                >
                  康邻
                </Button>
              )}
              <Button
                onClick={() => {
                  onSettingPayVisibleKanglin({
                    id: 1,
                    tenantId: location.search.replace('?', ''),
                    visible: true,
                  })
                  // setSettingPayVisible({
                  //   id: 1,
                  //   tenantId: location.search.replace('?', ''),
                  //   visible: true,
                  // })
                }}
                type='link'
              >
                添加聚合支付
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='代煎设置'>
              <Button
                onClick={() => {
                  onIsReplaceMakeModalVisible(true)
                  // setIsReplaceMakeModalVisible(true)
                }}
                type='link'
              >
                {replaceMakeStatus == 1 ? '开通代煎' : '代煎选项设置'}
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='药店处方在线申请渠道'
              name={Checks.YDCFZXSQ}
            >
              <Checkbox.Group>
                <Checkbox value={'KJ'}>康久互联网医院</Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </Row>
        {/* <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '190px',
          }}
        >
          <div
            style={{
              height: '50px',
              marginRight: '30px',
            }}
          >
            <Button onClick={() => form.resetFields()}>取消</Button>
          </div>
          <div
            style={{
              height: '50px',
            }}
          >
            <Button htmlType='submit' type='primary'>
              确认
            </Button>
          </div>
        </Row> */}
      </Form>
      <div className={styles.btnWrap}>
        <Button onClick={form.submit} type='primary'>
          确认
        </Button>
      </div>
    </div>
  )
}
